import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AppLink from "../router/app-link";
import Button from "../tailwind/button";
import { useContext } from "react";
import AuthContext from "../auth-context";
import { Mediums } from "../../types/mediums";

export interface IPageToolsProps {
  hasOpenTicket: boolean;
  medium: string;
  isCompany: boolean;
}

function PageTools({ hasOpenTicket, isCompany, medium }: IPageToolsProps) {
  let context = useContext(AuthContext),
    { serviceType } = context;

  return (
    <div className="page-tools">
      <div className="action-buttons text-nowrap">
        <Button
          className="bgc-white btn-light-secondary mx-0"
          dataToggle="tooltip"
          dataPlacement="top"
          title="سوابق مالی"
        >
          <AppLink to="/withdraws">
            <FontAwesomeIcon icon="money-bill-wave" className="text-primary" />
          </AppLink>
        </Button>

        <Button
          className="btn bgc-white btn-light-secondary mx-0"
          dataToggle="tooltip"
          title="ثبت تیکت پشتیبانی"
        >
          <AppLink to="/tickets">
            <FontAwesomeIcon
              icon={["far", "envelope-open"]}
              className="text-purple-d1"
            />
            <small className="ml-2 mr-1">تیکت ها</small>
          </AppLink>
        </Button>

        {serviceType === Mediums.ADSL && (
          <Button
            className="bgc-white btn-light-secondary mx-0"
            disabled={hasOpenTicket}
            data-toggle="tooltip"
            data-placement="top"
            title="خرید گیگ"
          >
            <AppLink to="purchase/packages">
              <FontAwesomeIcon icon="plus-circle" className="text-green" />
              <small className="ml-2 mr-1">خرید ترافیک</small>
            </AppLink>
          </Button>
        )}
        {serviceType === Mediums.NGN && isCompany && (
          <Button
            className="bgc-white btn-light-secondary mx-0"
            disabled={hasOpenTicket}
            data-toggle="tooltip"
            data-placement="top"
            title="خرید کانال"
          >
            <AppLink to="/purchase/ngnChannel">
              <FontAwesomeIcon icon="plus-circle" className="text-green" />
              <small className="ml-2 mr-1">خرید کانال</small>
            </AppLink>
          </Button>
        )}
      </div>
    </div>
  );
}

export default PageTools;
